(() => {
  'use strict';

  const banner = document.querySelector('[data-monarch-cookie-banner]');
  if (!banner || banner.dataset.initialized === 'true') return;
  banner.dataset.initialized = 'true';

  const status = banner.querySelector('[data-consent-status]');
  const retry = banner.querySelector('[data-consent-retry]');
  const close = banner.querySelector('[data-consent-close]');
  const details = banner.querySelector('[data-consent-details]');
  const title = banner.querySelector('h2');
  const fields = Array.from(banner.querySelectorAll('[data-consent-category]'));
  const choices = Array.from(banner.querySelectorAll('[data-consent-action]'));
  const preferenceButtons = Array.from(document.querySelectorAll('[data-cookie-preferences]'));
  let api = null;
  let busy = false;
  let operation = 0;
  let timeout = null;
  let lastChoice = null;
  let opener = null;

  const display = (visible) => {
    banner.hidden = !visible;
    document.documentElement.classList.toggle('monarch-cookie-banner-open', visible);
    document.dispatchEvent(new CustomEvent('monarch:cookie-banner-change', { detail: { open: visible } }));
  };

  const setBusy = (value, message = '') => {
    busy = value;
    banner.setAttribute('aria-busy', String(value));
    [...choices, ...fields].forEach((control) => { control.disabled = value || !api; });
    close.disabled = value;
    retry.hidden = true;
    status.textContent = message;
    status.hidden = !message;
    banner.dataset.error = 'false';
  };

  const fail = () => {
    clearTimeout(timeout);
    setBusy(false, banner.dataset.errorMessage);
    banner.dataset.error = 'true';
    retry.hidden = false;
    close.hidden = false;
    display(true);
  };

  const populate = (consent) => {
    fields.forEach((field) => { field.checked = consent[field.dataset.consentCategory] === 'yes'; });
  };

  const finish = () => {
    clearTimeout(timeout);
    setBusy(false);
    display(false);
    details.open = false;
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    else if (banner.contains(document.activeElement)) preferenceButtons[0]?.focus({ preventScroll: true });
    opener = null;
    lastChoice = null;
  };

  const save = (choice) => {
    if (busy || !api) return;
    const currentOperation = ++operation;
    lastChoice = choice;
    setBusy(true, banner.dataset.savingMessage);
    timeout = setTimeout(() => {
      if (currentOperation !== operation) return;
      operation += 1;
      fail();
    }, 10000);
    try {
      api.setTrackingConsent(choice, (result) => {
        if (currentOperation !== operation) return;
        clearTimeout(timeout);
        try {
          if (result?.error) return fail();
          const recorded = api.currentVisitorConsent();
          const confirmed = Object.entries(choice).every(([key, value]) => recorded[key] === (value ? 'yes' : 'no'));
          if (!confirmed) return fail();
          populate(recorded);
          finish();
        } catch {
          fail();
        }
      });
    } catch {
      operation += 1;
      fail();
    }
  };

  const initialize = () => {
    if (busy) return;
    const currentOperation = ++operation;
    setBusy(true, banner.dataset.loadingMessage);
    timeout = setTimeout(() => {
      if (currentOperation !== operation) return;
      operation += 1;
      fail();
    }, 10000);
    const load = () => {
      if (currentOperation !== operation) return;
      if (typeof window.Shopify?.loadFeatures !== 'function') {
        setTimeout(load, 100);
        return;
      }
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (currentOperation !== operation) return;
          clearTimeout(timeout);
          if (error) return fail();
          try {
            const loaded = window.Shopify.customerPrivacy;
            if (!loaded || ['currentVisitorConsent', 'shouldShowBanner', 'setTrackingConsent'].some((method) => typeof loaded[method] !== 'function')) return fail();
            const consent = loaded.currentVisitorConsent();
            const hasChoice = ['analytics', 'marketing', 'preferences'].every((key) => consent[key] === 'yes' || consent[key] === 'no');
            const shouldShow = loaded.shouldShowBanner() && !hasChoice;
            api = loaded;
            populate(consent);
            setBusy(false);
            close.hidden = !opener;
            display(Boolean(opener) || shouldShow);
          } catch {
            api = null;
            fail();
          }
        });
      } catch {
        operation += 1;
        fail();
      }
    };
    load();
  };

  preferenceButtons.forEach((button) => {
    button.hidden = false;
    button.addEventListener('click', (event) => {
      event.preventDefault();
      opener = button;
      close.hidden = false;
      details.open = true;
      display(true);
      title.focus({ preventScroll: true });
      if (busy) return;
      if (!api) return initialize();
      try {
        populate(api.currentVisitorConsent());
        setBusy(false);
      } catch {
        api = null;
        fail();
      }
    });
  });

  choices.forEach((button) => {
    button.addEventListener('click', () => {
      const selected = button.dataset.consentAction;
      const choice = { analytics: false, marketing: false, preferences: false, sale_of_data: false };
      fields.forEach((field) => {
        choice[field.dataset.consentCategory] = selected === 'save' ? field.checked : selected === 'accept';
      });
      save(choice);
    });
  });

  retry.addEventListener('click', () => {
    if (lastChoice && api) save(lastChoice);
    else initialize();
  });
  close.addEventListener('click', () => { if (!busy) finish(); });
  banner.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !close.hidden && !busy) finish();
  });

  initialize();
})();
